import { Provider } from "@angular/core";
import { DeviceDetectorService } from "ngx-device-detector";
import { MessageService } from "primeng/api";
import { Globals } from "./app.globals";
import { AdminAuth } from "./services/auth/admin.auth";
import { DmsSharedAuth } from "./services/auth/dms-shared.auth";
import { HealthAndSafetyAuth } from "./services/auth/health-and-safety.auth";
import { LocationAuth } from "./services/auth/location.auth";
import { ProjectAuth } from "./services/auth/project.auth";
import { PublicFormAuth } from "./services/auth/public-form.auth";
import { QSAuth } from "./services/auth/qs.auth";
import { QualityAssuranceAuth } from "./services/auth/quality-assurance.auth";
import { SiteworkAuth } from "./services/auth/sitework.auth";
import { UserAuth } from "./services/auth/user.auth";
import { HealthAndSafetyAdminService } from "./services/health-and-safety/admin-service";
import { CanNavDeactivateService } from "./services/nav.deactivate.service";
import { NavService } from "./services/nav.service";
import { QualityAssuranceAdminService } from "./services/quality-assurance/admin-service";
import { AsyncModalService } from "./services/shared/async-modal-service";
import { BreadcrumbService } from "./services/shared/breadcrumb-service";
import { ContextMenuService } from "./services/shared/context-menu-service";
import { CsvGeneratorService } from "./services/shared/csv-generator-service";
import { ImageViewerService } from "./services/shared/image-viewer-service";
import { LoaderService } from "./services/shared/loader-service";
import { ProgressMeasurementService } from "./services/shared/progress-measurement-service";
import { RouteDataService } from "./services/shared/routeData.service";
import { UserService } from "./services/user.service";
import { GridEventService } from "./services/grid.service";
import { APP_ID } from '@angular/core';

export const appProviders: Provider[] = [
    AdminAuth,
    AsyncModalService,
    BreadcrumbService,
    CanNavDeactivateService,
    ContextMenuService,
    CsvGeneratorService,
    DeviceDetectorService,
    DmsSharedAuth,
    Globals,
    HealthAndSafetyAdminService,
    HealthAndSafetyAuth,
    ImageViewerService,
    LoaderService,
    LocationAuth,
    MessageService,
    NavService,
    ProgressMeasurementService,
    ProjectAuth,
    PublicFormAuth,
    QSAuth,
    QualityAssuranceAdminService,
    QualityAssuranceAuth,
    RouteDataService,
    SiteworkAuth,
    UserAuth,
    UserService,
    GridEventService,
    { provide: APP_ID, useValue: "ng-cli-universal" }
];
